import {
  MY_TEAMS,
  REPORT_ALL_CANDIDATES,
  REPORT_ALL_ORDERS,
  REPORT_ALL_REFERRALS,
  REPORT_BUSINESS_BUILDER_COACHES,
} from '/enum/records.enum';

export function generateOnPress({
  navigate,
  recordsName,
  setSelectedSortParam,
  sortParams,
}: any) {
  return () =>
    navigate('records-sort-screen', {
      recordsName,
      setSelectedSortParam,
      sortParams,
    });
}

export const reportsWithArrowSortButton = [
  REPORT_ALL_ORDERS,
  REPORT_ALL_CANDIDATES,
  REPORT_BUSINESS_BUILDER_COACHES,
  REPORT_ALL_REFERRALS,
];
export const reportsWithArrowSortButtonTeamOrg = [MY_TEAMS];
